import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { AuthInfo } from '../../types/contexts/AuthContext'
import { Credentials } from '../../types/user/auth'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useLogin() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { poster } = useFetch()
  const { saveAuthInfo } = useAuth()

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const login = async (credentials: Credentials) => {
    setLoading(true)
    try {
      const data = await poster<AuthInfo>(
        `${CONFIG.BOUNCE_API}/api/v1/auth/login`,
        credentials,
        'application/json'
      )
      if (data) {
        saveAuthInfo(data)
        setError(null)
        return data
      }
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return { login, loading, error, resetState }
}
